import React, {useState} from 'react';
import {Tabs, Tab, Box, AppBar, Toolbar} from '@mui/material';
import Typography from "@mui/material/Typography";
import SwipeableViews from 'react-swipeable-views';

import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

// Sections
import {ContactListComponent} from './ContactListComponent';
import {GroupListComponent} from './GroupListComponent';
import {ChannelListComponent} from './ChannelListComponent';
import {DialogComponent} from './DialogComponent';

import {URL_GROUP_AVATAR} from '../../Const'; // adjust path

const MessengerMain = () => {
    const [index, setIndex] = useState(3);
    const avatar = null; // or actual avatar URL
    const title = "پیام‌رسان همه‌کارا"; // replace dynamically if needed

    const handleTabChange = (_, newIndex) => setIndex(newIndex);
    const handleSwipeChange = (newIndex) => setIndex(newIndex);

    const tabs = [
        {label: "مخاطبین", icon: <GroupsOutlinedIcon/>},
        {label: "گروه", icon: <GroupWorkOutlinedIcon/>},
        {label: "کانال", icon: <CampaignOutlinedIcon/>},
        {label: "پیام‌ها", icon: <ChatBubbleOutlineOutlinedIcon/>},
    ];

    return (
        <Box >

            <AppBar
                position="static"
                style={{
                    background: 'rgba(238,238,238,0.3)',
                    boxShadow: 'none',
                }}
            >
                <Toolbar style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingLeft: 8,
                    paddingRight: 8,
                    overflow: 'hidden',
                    width: '100%',
                }}>
                    {/* Left Icon or Avatar */}
                    {avatar == null ? (
                        <img
                            src="https://icons.veryicon.com/png/o/miscellaneous/basic-icon/message-54.png"
                            alt="icon"
                            style={{width: 40, height: 40}}
                        />
                    ) : (
                        <img
                            style={{
                                borderRadius: '50%',
                                width: 46,
                                height: 46,
                            }}
                            alt="avatar"
                            src={URL_GROUP_AVATAR + avatar}
                        />
                    )}

                    {/* Centered Title */}
                    <Typography
                        variant="h6"
                        noWrap
                        style={{
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontWeight: 600,
                            fontSize: 18,
                            color: 'black',
                            fontFamily: 'IRANSans, Roboto, Arial',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {title}
                    </Typography>

                    {/* Right Spacer (same width as left icon for balance) */}
                    <div style={{width: 40}}/>
                </Toolbar>
            </AppBar>


            {/* Tabs Navigator */}
            <Tabs
                value={index}
                onChange={handleTabChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
                TabIndicatorProps={{style: {backgroundColor: '#FF1744'}}}
                sx={{
                    backgroundColor: '#f5f5f5',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    '& .MuiTab-root': {
                        color: '#888',
                        fontWeight: 'normal',
                    },
                    '& .Mui-selected': {
                        color: '#FF1744',
                        fontWeight: 'bold',
                    },
                }}
            >
                {tabs.map((tab, i) => {
                    const selected = index === i;
                    const color = selected ? '#FF1744' : '#888';

                    return (
                        <Tab
                            key={i}
                            disableRipple
                            label={
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    flexDirection: 'row-reverse',
                                    color
                                }}>
                                    {React.cloneElement(tab.icon, {style: {color}})}
                                    <Typography style={{fontSize: 14, color}}>{tab.label}</Typography>
                                </div>
                            }
                        />
                    );
                })}
            </Tabs>

            {/* Pages */}
            <SwipeableViews
                index={index}
                onChangeIndex={handleSwipeChange}
                enableMouseEvents
                resistance
                axis="x-reverse"
                style={{ overflow: 'auto', direction: 'rtl'}}
            >
                <Box p={0} style={{direction: 'rtl'}}><ContactListComponent/></Box>
                <Box p={0} style={{direction: 'rtl'}}><GroupListComponent/></Box>
                <Box p={0} style={{direction: 'rtl'}}><ChannelListComponent/></Box>
                {/* Optional: AppBar or Tabs here */}
                {/* This is the scrollable part */}
                <Box sx={{overflowY: 'hidden' }}>
                    <DialogComponent/>
                </Box>
            </SwipeableViews>
        </Box>
    );
};

export default MessengerMain;
